const initialState = {
    itemPerPage:10,
    currentPage: 0,
    paginatedData: {},
    totalPage: 0
};
export default initialState;